const TabType = Object.freeze({ insights: 1, stories: 2, kpiStreams: 3, modules: 5 });
export default TabType;